import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBookingDetailUrl } from '~helpers/order';
import { useHistory } from 'react-router-dom';

const GoToCheck = ({ bookingJourney, referenceId }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
    history.push(getBookingDetailUrl(bookingJourney, referenceId, 'Students'));
  };

  return (
    bookingJourney &&
    referenceId && (
      <a className="leads-card__link" href="#" onClick={handleClick}>
        {t('cms:cms.students.list.column.go_to_check')}
      </a>
    )
  );
};

export default GoToCheck;
